(function () {
  'use strict';
  const presets = [
    {id: 'aurore', title: 'La combinazione Aurore', text: 'Collana, orecchini, bracciale e anello della linea Aurore.', handles: ['aurore-necklace', 'aurore-earrings', 'aurore-bracelet', 'aurore-ring']},
    {id: 'eclat', title: 'La combinazione Éclat', text: 'Quattro gioielli della linea Éclat, da personalizzare come vuoi.', handles: ['eclat-necklace', 'eclat-earrings', 'eclat-bracelet', 'eclat-ring']},
    {id: 'mix', title: 'Il tuo mix', text: 'Murmure, Alma, Lucie e Dune: quattro modelli da abbinare.', handles: ['murmure-necklace', 'alma-earrings', 'lucie-bracelet', 'dune-ring']}
  ];
  const money = n => new Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(n / 100);
  const make = (tag, cls, text) => {const el = document.createElement(tag); if (cls) el.className = cls; if (text !== undefined) el.textContent = text; return el;};
  const available = v => v.available && v.stock > 0;
  function photo(product, variant) {
    const el = make('div', 'ma-product-photo');
    const src = variant?.image || product.image;
    if (src) {const img = make('img'); img.src = src; img.alt = product.title; img.width = 600; img.height = 750; img.loading = 'lazy'; el.append(img);}
    else {el.append(make('span', 'ma-monogram', product.collection || product.title.split(' ')[0]), make('small', '', 'Fotografia in preparazione'));}
    if (product.isNew) el.append(make('span', 'ma-novelty-badge', 'Novità'));
    return el;
  }
  async function load(root) { const products = await window.MACatalog.flow(); return root.dataset.catalog === 'true' ? products : products.filter(p => p.eligible); }
  function candidates(preset, products) {
    return preset.handles.map(handle => products.find(p => p.handle === handle)).filter(Boolean);
  }
  function presetCard(preset, products, action) {
    const selected = candidates(preset, products);
    if (selected.length !== 4 || selected.some(p => !p.variants.some(available))) return null;
    const card = make('article', 'ma-preset-card');
    const images = make('div', 'ma-preset-images'); selected.forEach(p => images.append(photo(p)));
    card.append(images, make('h3', '', preset.title), make('p', '', preset.text));
    card.append(make('p', 'ma-preset-names', selected.map(p => p.title).join(' · ')), make('p', 'ma-preset-price', '4 gioielli · 50 € · 12,50 € ciascuno'), action(preset));
    return card;
  }
  window.MASetData = {presets, money, make, available, photo, load, candidates, presetCard};
})();

